(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  class AetheriumArticle extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.aetherium-article__body');
      this.progress = this.querySelector('.aetherium-article__progress span');
      this.toc = this.querySelector('.aetherium-article__toc');
      this.list = this.toc?.querySelector('ol');
      this.headings = Array.from(this.body?.querySelectorAll('h2') || []);
      this.links = [];
      this.frame = null;

      if (!this.headings.length || !this.list) {
        this.toc?.setAttribute('hidden', '');
      } else {
        this.buildTableOfContents();
        this.observeSections();
        if (window.matchMedia('(max-width: 989px)').matches) {
          this.toc.querySelector('details')?.removeAttribute('open');
        }
      }

      this.updateProgress = this.updateProgress.bind(this);
      window.addEventListener('scroll', this.updateProgress, { passive: true });
      window.addEventListener('resize', this.updateProgress, { passive: true });
      this.updateProgress();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateProgress);
      window.removeEventListener('resize', this.updateProgress);
      this.observer?.disconnect();
    }

    buildTableOfContents() {
      const usedIds = new Set();

      this.headings.forEach((heading, index) => {
        let id = heading.id || heading.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '') || `section-${index + 1}`;
        const baseId = id;
        let suffix = 2;

        while (usedIds.has(id) || document.getElementById(id)) {
          id = `${baseId}-${suffix}`;
          suffix += 1;
        }

        usedIds.add(id);
        heading.id = id;

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        this.list.append(item);
        this.links.push(link);
      });
    }

    observeSections() {
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

        if (!visible) return;

        this.links.forEach((link) => {
          if (link.hash === `#${visible.target.id}`) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }, { rootMargin: '-15% 0px -70% 0px' });

      this.headings.forEach((heading) => this.observer.observe(heading));
    }

    updateProgress() {
      if (this.frame) return;

      this.frame = requestAnimationFrame(() => {
        const start = this.offsetTop;
        const distance = Math.max(this.offsetHeight - window.innerHeight, 1);
        const value = Math.min(Math.max((window.scrollY - start) / distance, 0), 1);
        this.progress.style.width = `${value * 100}%`;
        this.frame = null;
      });
    }
  }

  if (!customElements.get('aetherium-article')) {
    customElements.define('aetherium-article', AetheriumArticle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
